<template>
  <div class="station-card-timer" :class="[ status ]">
    <div class="label f8">{{ $t('Ends At') }} {{ endTimePretty }}</div>
    <div class="timeleft f3">{{ timeLeft }}</div>
    <small class="f6" v-if="station._pausedAt">{{ $t('Paused') }}</small>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';

@Component({
  props: {
    station: {
      required: true,
      type: Object,
    },
    currentTime: {
      required: true,
      type: String,
    },
    twentyFourHourTime: {
      required: true,
      type: Boolean,
    },
  },
})
export default class StationCardTimer extends Vue {
  status = null;

  get endTimePretty () {
    let endTimeMoment = moment(this.station._endTime);

    if (this.station._pausedAt) {
      endTimeMoment = moment(this.currentTime).add(this.station._pausedDuration, 'seconds');
    }

    if (this.twentyFourHourTime) {
      return endTimeMoment.format('H:mm');
    } else {
      return endTimeMoment.format('h:mm a');
    }
  }

  get timeLeft () {
    let diff;

    if (this.station._pausedAt) {
      diff = this.station._pausedDuration * 1000;
      this.emitStatus('paused');
    } else {
      diff = moment(this.station._endTime).diff(moment(this.currentTime));
      this.emitStatus(diff);
    }

    return DateHelper.formatMillisecondsToHMS(diff);
  }

  emitStatus (diff) {
    let newStatus;

    if (diff !== 'paused') {
      if (diff <= 300000) { newStatus = '-warning'; }
      if (diff <= 60000) { newStatus = '-error'; }
      if (diff <= 0) { newStatus = '-ended'; }
    } else {
      newStatus = '-paused';
    }

    if (newStatus !== this.status) {
      this.status = newStatus;
      this.$emit('timerStatusChange', newStatus);
    }
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.station-card-timer {
  & small {
    color: var(--colorErrorFlat);
  }

  &.-warning {
    & .label,
    & .timeleft {
      color: var(--colorErrorFlat);
    }
  }

  &.-error {
    & .label,
    & .timeleft {
      color: var(--colorSBRedFlat);
    }
  }

  & .label {
    margin-bottom: var(--spacingXS);
  }
}
</style>
